<template>
    <collapsible-card :title="'Vessels'" v-show="vessels.length > 0" ref="cCard">
        <div class="cardContent vesselList">
            <div v-for="obj in vessels" :key="obj.mmsi">
                <div><img :src="picUrl(obj.mmsi)" :id="'mmsi' + obj.mmsi" class="vesselPic"></div>
                <div class="vesselInfo">
                    <div class="vesselMainInfo">
                        <router-link :to="{name: 'Vessels', params: {mmsi: obj.mmsi}}" class="dataEmphasis link">{{obj.name}}</router-link>
                    </div>
                    <show-more>
                        <div class="vesselDetails">
                            <p v-if="obj.currentPort" style="text-align: center; font-style: italic; text-decoration: underline;"><span>In port {{obj.currentPort.port.name}} for {{obj.currentPort.minuteDelta}} minutes</span></p>
                            <p v-if="obj.deckSize">Deck Size: <span class="dataEmphasis">{{obj.deckSize}}</span></p>
                            <p v-if="obj.topSpeed">Top Speed: <span class="dataEmphasis">{{obj.topSpeed}}</span></p>
                            <p v-if="obj.capabilities">Capabilities: <span class="dataEmphasis">{{obj.capabilities}}</span></p>
                        </div>
                    </show-more>
                    <a :href="obj.specLink" v-if="obj.specLink" target="_blank" class="dataEmphasis link">Link to Specs</a>
                </div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import axios from 'axios';
import ShowMore from '../ShowMore.vue';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'provider-vessels',
    components: {
        ShowMore,
        CollapsibleCard
    },
    data: () => ({
        vessels: []
    }),
    methods: {
        updateInfo: function(vessels) {
            var globv = this;
            globv.vessels = vessels.map(x => {
                x['minuteDelta'] = Math.floor((Date.now() - x['ingress']) / 60000);
                return x;
            });
            globv.$refs.cCard.adjustHeight();
        },
        picUrl: function(mmsi) {
            axios.get(`https://www.raptor1.io/images/ships/${mmsi}.jpg`).then( response => {
                if (response.status < 300) {
                    document.getElementById('mmsi' + mmsi).src = `https://www.raptor1.io/images/ships/${mmsi}.jpg`;
                }
            }).catch((error) => {
                if (error.response.status !== 404) {
                    console.log(error.response);
                }
            });

            return "/logo.png"
        },
        reset: function() {
            var globv = this;
            globv.vessels = [];
        }
    }
}
</script>